import { Observable, Subject } from "rxjs";
import { HandledError } from '../models/HandledError';

class BusServiceCtrl {

    private terminateSubject: Subject<boolean> = new Subject();
    private errorSubject: Subject<HandledError> = new Subject();

    public get $terminate(): Observable<boolean> {
        return this.terminateSubject.asObservable();
    }

    public get $error(): Observable<HandledError> {
        return this.errorSubject.asObservable();
    }

    public terminateRequest(confirm: boolean) {
        this.terminateSubject.next(confirm);
    }

    public errorLog(error: HandledError) {
        this.errorSubject.next(error);
    }
}


export const AVBusService = new BusServiceCtrl();
